import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ITEMS_PER_PAGE } from 'src/app/shared/constants/pagination.constants';

import { HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { JhiAlertService, JhiEventManager, JhiParseLinks } from 'ng-jhipster';
import { Subscription } from 'rxjs';
import { Principal, StateStorageService } from 'src/app/core';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { currenyMaskService } from '../../shared/currencyMask.service';
import { BulkDeclarationService } from './bulk-declaration.service';

@Component({
    selector: 'jhi-open-rejected-bulk-declaration',
    templateUrl: './open-rejected-bulk-declaration.component.html',
    styles: []
})
export class OpenRejectedBulkDeclarationComponent implements OnInit {

    public readonly RoleUtil=RoleUtil;
    
    currentAccount: any;

    rulesRequest = [];

    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;

    constructor(
        private bulkDeclarationService: BulkDeclarationService,
        private modalService: BsModalService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private eventManager: JhiEventManager,
        private currenyMask: currenyMaskService,
        private stateStorageService: StateStorageService,
        private languageChangeService:LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
      /*   this.page = 1;
        this.predicate = 'id'; */
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if(this.itemsPerPage == 25 && this.page >1){
            //   this.page =1;
            // }
          });
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
            }
    });
      
    }

    ngOnInit() {
        this.stateStorageService.resetBulkCertificateDTO();
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });
        this.registerChangeInManualRequest();
    }


    navigateBulkDeclarationShipments() {
        if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientAuthorities)) {
            this.router.navigateByUrl('/my-declaration/declare-shipment');
        } else if (this.principal.hasAnyAuthorityDirect(RoleUtil.BrokerUnderwriteInsurerAuthorities)) {
            this.router.navigateByUrl('/my-declaration/broker-get-declaration');
        }
    }


    ngOnDestroy() {
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: any) {
        return item.id;
    }

    registerChangeInManualRequest() {
        this.eventSubscriber = this.eventManager.subscribe('BulkPendingListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateManualRequests(data: any[], headers: HttpHeaders) {
        // this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.rulesRequest = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    loadAll() {
        this.searchText = '';
        this.bulkDeclarationService
            .queryWithUrl('/open-rejected', {
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/my-declaration/open-rejected/search'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/my-declaration/open-rejected',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }

    searchItems() {
        if (this.searchText) {
            var pNo = 0;
             var size = this.itemsPerPage;
            if (this.flag == true) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            }
            this.principal
                .searchQuery(this.searchText, 'bulk-certificate-requests/open-rejected/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }
    onChange(value){
        this.page = 0;
        this.itemsPerPage=value
        this.loadAll();
    }

}
